import { css } from '@mui/styled-engine'

import type { HAVDesignTokensInterface } from '../interfaces'
import { havDefault01Text } from './Texts'

const havPagination = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  color: ${HAVDesignTokens.palette.main.primary};
  ${havDefault01Text(HAVDesignTokens)};
  width: fit-content;

  .MuiPaginationItem-root {
    ${havDefault01Text(HAVDesignTokens)}
    color: ${HAVDesignTokens.palette.main.primary};
    min-height: ${HAVDesignTokens.spacing.padding.height.xbig};
    border: ${HAVDesignTokens.shape.border.outline.thin}
      ${HAVDesignTokens.palette.main.primary};

    &.Mui-selected {
      color: ${HAVDesignTokens.palette.neutral.white};
      background-color: ${HAVDesignTokens.palette.main.tertiary};
      border: ${HAVDesignTokens.shape.border.outline.thin}
        ${HAVDesignTokens.palette.main.tertiary};

      &:hover {
        background-color: ${HAVDesignTokens.palette.main.tertiary};
      }
    }

    .MuiPaginationItem-outlinedPrimary {
      color: ${HAVDesignTokens.palette.main.tertiary};
      user-select: none;
      pointer-events: none;
    }
  }
  .MuiPaginationItem-page {
    padding-top: ${HAVDesignTokens.spacing.base}px;
  }

  div.MuiPaginationItem-root {
    min-width: ${HAVDesignTokens.spacing.padding.height.big};
    padding-top: ${HAVDesignTokens.spacing.base}px;
    color: ${HAVDesignTokens.palette.main.primary};
    border: none;
  }

  ul > li {
    margin: 0 2px;

    @media (max-width: 320px) {
      margin: 0 0.6px;
    }
  }
`

export { havPagination }
